(function(){
  function init(){
    var blocks = document.querySelectorAll('#shopify-section-footer .footer-block.grid__item');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var heading = block.querySelector('.footer-block__heading');
      if (!heading || heading.textContent.trim().toUpperCase() !== 'FIND US') continue;
      if (block.querySelector('.cc-footer-map')) return;
      var addressPara = block.querySelector('.footer-block__details-content > p');
      if (!addressPara) return;
      var wrap = document.createElement('div');
      wrap.className = 'cc-footer-map';
      var img = document.createElement('img');
      img.src = 'https://www.customcartons.co.nz/cdn/shop/files/unnamed-2.jpg?width=320';
      img.alt = 'Map to Custom Cartons, 196 Matakokiri Drive, Tauriko';
      img.loading = 'eager';
      img.width = 320;
      wrap.appendChild(img);
      addressPara.insertAdjacentElement('afterend', wrap);
      return;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
